/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/styles/global.css';
// import 'normalize.css';

// Ensure Firebase only initializes in the browser
export const onClientEntry = () => {
  // Initialize Firebase here if needed
  if (typeof window !== 'undefined') {
    // Any browser-only initialization can go here
    console.log('Gatsby client entry - browser environment ready');
  }
};
